


































































































































































import Vue from 'vue';

export default Vue.extend({
  name: 'Surprise',
  props: {
    isSelected: Boolean,
  },
});
